import styled from 'styled-components';
import { StyledTheme, StyledThemeSizesMixin } from '../../../../styles';
import { RadioInputClassBase } from './radio-input-class-base.styles';

export const RadioInputStyles = styled.div<{ theme: StyledTheme }>`
  ${StyledThemeSizesMixin}

  &.radioInputBase {
    ${RadioInputClassBase}
  }
`;
